<template>
    <div>
        <base-loading :visible="isLoading" />
        <div class="grid grid-cols-12 gap-4">
            <div class="col-span-full md:col-span-2 md:col-start-11  xs:col-start-1">
                <search-input v-model="search" @search="onSearch" @clear="onSearch" />
            </div>
            <div class="col-span-full col-start-1">
                <report-transactions-table
                    :items="items" 
                    @loadMore="loadMore" 
                    @details="details"
                    @sortChanged="onSortChanged" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useNotifier } from '@/composables/useNotifier'
import { useReportTransactions } from '../../composables/useReportTransactions'
import { useNavigator } from '@/composables/useNavigator'
import ReportTransactionsTable from './components/ReportTransactionsTable'
import BaseLoading from '@/views/app/components/BaseLoading'
import SearchInput from '@/views/app/components/SearchInput'
const { getParam } = useNavigator()
const { notify } = useNotifier()
const reportTransactions = useReportTransactions()
const items = computed(() => reportTransactions.state.items)
const currentPage = computed(() => reportTransactions.state.currentPage)
const lastPage = computed(() => reportTransactions.state.lastPage)
const isLoading = computed(() => reportTransactions.state.loading)
const search = ref('')
const sort = ref({})
const report = getParam('report')

const loadData = async (params = {}) => {
    const payload = {
        page: reportTransactions.state.currentPage || 1,
        report:report.value,
        search: search.value,
        column: sort.value.column,
        order: sort.value.order,
        ...params
    }
    const result = await reportTransactions.getReportTransactions(payload)
    if (!result.success) notify({ title: 'error', text: 'message_error', color: 'danger' })
}

const loadMore = async () => {
    if (currentPage.value >= lastPage.value) return
    const newPage = reportTransactions.state.currentPage + 1
    await loadData({ page: newPage })
}

const onSearch = async () => {
    await loadData({ page: 1, search: search.value })
}

const onSortChanged = async (sortData) => {
    sort.value.column = sortData.key
    sort.value.order = sortData.order
    await loadData({ column: sort.value.column, order: sort.value.order })
}


onMounted(() => loadData())

</script>
